import { computed } from 'vue';
import { useMyPatientsStore } from '@/store/helpers';

export function useCardActions(props, emit) {
  const { patientInfoStore } = useMyPatientsStore();

  const isCardPinned = computed(() => patientInfoStore.getters.isCardPinned(props.cardData));

  const handlePinCard = () => {
    emit('pin-card', props.cardData);
  };

  const handleUnpinCard = () => {
    emit('unpin-card', props.cardData);
  };

  return {
    isCardPinned,
    handlePinCard,
    handleUnpinCard,
  };
}
